import { device } from 'constants/media-query'
import styled from 'styled-components/macro'

export const StyledModal = styled.div`
  text-align: start;
  font-size: 14px;
  font-weight: 500;
  position: fixed;
  max-height: 70%;
  top: 15%;
  overflow: auto;
  width: max-content;
  font-family: ${({ theme }) => theme.fonts.inter}, sans-serif;

  @media ${device.desktop} {
    position: absolute;
    max-width: 922px;
    max-height: 536px;
    flex-shrink: 0;
    top: 132px;
    margin-inline: 100px;
    overflow: unset;
  }
`

export const StyledModalTop = styled.div`
  display: flex;
  flex-direction: column;
  @media ${device.desktop} {
    flex-direction: row;
    justify-content: space-between;
  }
`
export const StyledTitelContainer = styled.div`
  display: flex;
  flex-direction: column-reverse;
  align-items: flex-start;
  gap: 20px;
  @media ${device.desktop} {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
  }
`

export const StyledTitle = styled.h2`
  font-size: 20px;
  font-weight: 500;
  @media ${device.desktop} {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`

export const StyledBackBtn = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  width: 28px;
  height: 28px;
  @media ${device.desktop} {
    width: 21px;
    height: 21px;
  }
`

export const StyledModalNameDob = styled.div`
  display: flex;
  flex-direction: column;
  gap: 23px;
  font-size: 14px;
  font-weight: 500;
  text-align: start;
  @media ${device.desktop} {
    font-size: 16px;
    flex-direction: column;
    align-items: flex-start;
  }
`

export const StyledImageContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media ${device.desktop} {
    margin-top: 8px;
    padding-inline-start: 100px;
    padding-bottom: 0;
  }
`

export const StyledModalName = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: flex-start;
  @media ${device.desktop} {
    font-size: 16px;
    justify-content: space-between;
  }
`

export const StyledMiniTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 8px;
  @media ${device.desktop} {
    margin-top: 0px;
  }
`
//Address
export const AddressWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media ${device.desktop} {
    flex-direction: row;
    gap: 16px;
  }
`
//bottom buttons
export const StyledBtnContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-top: 44px;
  padding-bottom: 40px;
  margin-inline-start: auto;
  margin-block-start: auto;
  @media ${device.desktop} {
    flex-direction: row;
    padding-bottom: 0px;
    width: 300px;
  }
`
